module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-commercial-5-2bfef11dc4f959717d23243e275864f3.png";